import {useState} from 'react';

export type PreviewDeviceType = 'desktop' | 'mobile';

/**
 * プレビューのデバイス（表示幅）の state
 * - desktop: デスクトップ
 * - mobile: モバイル
 */
export function usePreviewDeviceState() {
  const [device, setDevice] = useState<PreviewDeviceType>('desktop');

  return {device, setDevice};
}
